import { useLocation } from "react-router-dom";
import { useSEO } from "@/lib/useSEO";

export default function SEOTracker() {
  const { pathname } = useLocation();
  useSEO(pathname);
  return null;
}
